import { useRoutes } from "react-router-dom";
import Routes from "../Constants/Routes";
import { lazyLoadRoutes } from "../Utils/LazyLoader";

const webRoutes = [
  {
    path: "/",
    children: [
      {
        path: "*",
        element: lazyLoadRoutes("NotFound", false),
      },
      {
        index: true,
        element: lazyLoadRoutes("HomePage", false),
      },
      {
        path: Routes.publicRoutes.KidneyFailure,
        element: lazyLoadRoutes("KidneyFailure", false),
      },
      {
        path: `${Routes.publicRoutes.ClinicDetails}/:slug`,
        element: lazyLoadRoutes("ClinicDetails", false),
      },
      {
        path: Routes.publicRoutes.HealingStories,
        element: lazyLoadRoutes("HealingStories", false),
      },
      {
        path: Routes.publicRoutes.OurCenters,
        element: lazyLoadRoutes("OurCenters", false),
      },
      {
        path: Routes.publicRoutes.PainManagement,
        element: lazyLoadRoutes("PainManagement", false),
      },
      {
        path: Routes.publicRoutes.Diseases,
        element: lazyLoadRoutes("Diseases", false),
      },
      {
        path: `${Routes.publicRoutes.DiseaseDetail}/:slug`,
        element: lazyLoadRoutes("DiseaseDetail", false),
      },
      {
        path: `${Routes.publicRoutes.DoctorDetail}/:slug`,
        element: lazyLoadRoutes("DoctorDetail", false),
      },
      {
        path: Routes.publicRoutes.TermsCondition,
        element: lazyLoadRoutes("TermsCondition", false),
      },
      {
        path: Routes.publicRoutes.ShippingPolicy,
        element: lazyLoadRoutes("ShippingPolicy", false),
      },
      {
        path: Routes.publicRoutes.ReturnPolicy,
        element: lazyLoadRoutes("ReturnPolicy", false),
      },
      {
        path: Routes.publicRoutes.PrivacyPolicy,
        element: lazyLoadRoutes("PrivacyPolicy", false),
      },
      {
        path: `${Routes.publicRoutes.ConsultDetail}/:id`,
        element: lazyLoadRoutes("ConsultDetail", false),
      },
      {
        path: Routes.publicRoutes.Videos,
        element: lazyLoadRoutes("Videos", false),
      },
      {
        path: `${Routes.publicRoutes.VideosDetail}/:id`,
        element: lazyLoadRoutes("VideosDetail", false),
      },
      {
        path: Routes.publicRoutes.Consult,
        element: lazyLoadRoutes("Consult", false),
      },
      {
        path: Routes.publicRoutes.OurExperts,
        element: lazyLoadRoutes("OurExperts", false),
      },
      {
        path: Routes.publicRoutes.EditorialPolicy,
        element: lazyLoadRoutes("EditorialPolicy", false),
      },
      {
        path: Routes.publicRoutes.AboutUs,
        element: lazyLoadRoutes("AboutUs", false),
      },
      {
        path: Routes.publicRoutes.ContentIntegrity,
        element: lazyLoadRoutes("ContentIntegrity", false),
      },
      {
        path: Routes.publicRoutes.Login,
        element: lazyLoadRoutes("Admin/Login", false),
      },
      // blog routes
      {
        path: Routes.publicRoutes.Blogs.Herbs.HerbsFood,
        element: lazyLoadRoutes("Blog/HerbsFood/HerbsFood", false),
      },
      {
        path: `${Routes.publicRoutes.Blogs.Herbs.HerbsFoodDetail}/:id`,
        element: lazyLoadRoutes("Blog/HerbsFood/HerbsFoodDetail", false),
      },
      {
        path: Routes.publicRoutes.Blogs.Medicine.MedicineBlog,
        element: lazyLoadRoutes("Blog/MedicineBlog/MedicineBlog", false),
      },
      {
        path: Routes.publicRoutes.Blogs.Video.VideoBlog,
        element: lazyLoadRoutes("Blog/VideoBlog/VideoBlog", false),
      },
      // admin routes
      {
        path: Routes.adminRoutes.Dashboard,
        element: lazyLoadRoutes("Admin/Dashboard", true),
      },
      {
        path: Routes.adminRoutes.Enquiry.ClinicEnquiry,
        element: lazyLoadRoutes("Admin/Enquiry/ClinicEnquiry", true),
      },
      {
        path: Routes.adminRoutes.Enquiry.DoctorEnquiry,
        element: lazyLoadRoutes("Admin/Enquiry/DoctorEnquiry", true),
      },
      {
        path: Routes.adminRoutes.Enquiry.ConsultEnquiry,
        element: lazyLoadRoutes("Admin/Enquiry/ConsultEnquiry", true),
      },
      {
        path: Routes.adminRoutes.Clinic.ClinicAdd,
        element: lazyLoadRoutes("Admin/Clinic/ClinicAdd", true),
      },
      {
        path: Routes.adminRoutes.Clinic.ClinicList,
        element: lazyLoadRoutes("Admin/Clinic/ClinicList", true),
      },
      {
        path: Routes.adminRoutes.DiseaseBlog.DiseaseAdd,
        element: lazyLoadRoutes("Admin/Disease/DiseaseAdd", true),
      },
      {
        path: `${Routes.adminRoutes.DiseaseBlog.DiseaseUpdate}/:id`,
        element: lazyLoadRoutes("Admin/Disease/DiseaseAdd", true),
      },
      {
        path: Routes.adminRoutes.DiseaseBlog.DiseaseList,
        element: lazyLoadRoutes("Admin/Disease/DiseaseList", true),
      },
      {
        path: Routes.adminRoutes.Doctors.DoctorsAdd,
        element: lazyLoadRoutes("Admin/Doctors/DoctorsAdd", true),
      },
      {
        path: Routes.adminRoutes.Doctors.DoctorsList,
        element: lazyLoadRoutes("Admin/Doctors/DoctorsList", true),
      },
      {
        path: Routes.adminRoutes.HealingStories.HealingStoriesAdd,
        element: lazyLoadRoutes("Admin/HealingStories/HealingStoriesAdd", true),
      },
      {
        path: Routes.adminRoutes.HealingStories.HealingStoriesList,
        element: lazyLoadRoutes("Admin/HealingStories/HealingStoriesList", true),
      },
      {
        path: Routes.adminRoutes.HerbsFood.HerbsFoodAdd,
        element: lazyLoadRoutes("Admin/HerbsFood/HerbsFoodAdd", true),
      },
      {
        path: Routes.adminRoutes.HerbsFood.HerbsFoodList,
        element: lazyLoadRoutes("Admin/HerbsFood/HerbsFoodList", true),
      },
      {
        path: Routes.adminRoutes.BlogVideos.BlogVideosAdd,
        element: lazyLoadRoutes("Admin/VideoBlog/BlogVideosAdd", true),
      },
      {
        path: Routes.adminRoutes.BlogVideos.BlogVideosList,
        element: lazyLoadRoutes("Admin/VideoBlog/BlogVideosList", true),
      },
      {
        path: Routes.adminRoutes.MedicineBlog.MedicineBlogAdd,
        element: lazyLoadRoutes("Admin/MedicineBlog/MedicineBlogAdd", true),
      },
       {
        path: `${Routes.adminRoutes.MedicineBlog.MedicineBlogUpdate}/:id`,
        element: lazyLoadRoutes("Admin/MedicineBlog/MedicineBlogAdd", true),
      },
      {
        path: Routes.adminRoutes.MedicineBlog.MedicineBlogList,
        element: lazyLoadRoutes("Admin/MedicineBlog/MedicineBlogList", true),
      },
    ],
  },
];

export function AppRoutes() {
  return useRoutes(webRoutes);
}
